import Instrument from "../instruments/Instrument";
import { Difficulty } from "../Difficulty";
import { Technique } from "../technique";
import { Game } from "./Game";
import { MixPuzzle } from "../mixpuzzles/types";
import { dedupe } from "util/dedupe";
import { instrumentToCategory } from "../instruments/InstrumentCategory";
import stringSorter from "util/stringSorter";

export interface GameRound {
  instruments: Instrument[];
  techniques: Technique[];
  games: Game[];
  difficulty: Difficulty;
}

export function getInstrumentCategoriesOfGameRound(game: GameRound) {
  return dedupe(
    game.instruments.map((instrument) => instrumentToCategory[instrument])
  ).sort(stringSorter);
}

export interface MixPuzzleRound {
  difficulty: Difficulty;
  mixPuzzle: MixPuzzle;
}

export function isMixPuzzleRound(
  round: GameRound | MixPuzzleRound
): round is MixPuzzleRound {
  return (round as MixPuzzleRound).mixPuzzle !== undefined;
}

export function isGameRound(
  round: GameRound | MixPuzzleRound
): round is GameRound {
  return (round as GameRound).games !== undefined;
}
